import React from 'react';
import PartnerAddContainer from '../../containers/partnermng/PartnerAddContainer';

const PartnerAddPage = () => {
  return (
    <PartnerAddContainer/>
  );
};

export default PartnerAddPage;
